import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

export const USER_CENTER_GET_USER_API_PATH = '/api/v4/bit/usercenter/getuser'
export const USER_CENTER_UPLOAD_AVATAR_AUDIT_API_PATH = '/api/v4/bit/usercenter/uploaduseravatarv3'
export const USER_CENTER_UPDATE_NICK_API_PATH = '/api/v4/bit/usercenter/updatenickv3'

export type UserCenterGetUserParams = {
  ApplicationType: 7
  CountryCode: string
  LanguageCode: string
  userId: string
}

export type UserCenterGetUserOptions = {
  headerUserId?: string
}

export type UserCenterGetUserPhoneByIdParams = {
  token: string
}

export type UserCenterGetUserPhoneByIdResponse = Record<string, any> | null

export type UserCenterUploadAvatarAuditParams = {
  userId: string
  ext: string
  base64: string
  isHead: string | number
  languageCode: string
}

export type UserCenterUploadAvatarAuditOptions = {
  headerUserId?: string
}

export type UserCenterUploadAvatarAuditResponse = Record<string, any> | null

export type UserCenterUpdateNickParams = {
  userId: string
  nick: string
  languageCode: string
  applicationType: 7
}

export type UserCenterUpdateNickOptions = {
  headerUserId?: string
}

export type UserCenterUpdateNickResponse = Record<string, any> | null

export type UserCenterUserFull = {
  nickavatar?: UserUpdateNickData
  base: UserCenterUserData
}

export type UserBaseInfo = {
  userId?: string
  nick?: string
  gender?: number
  userName?: string
  avatar?: string
  email?: string
  mobile?: string
  phone?: string
  mobileCode?: string
  sex?: string | number
  avatarFrame?: string
  wikinum?: string
  userStatus?: number
  showNickName?: string
  showAvataraddress?: string
  nickNameColor?: string
  NickNameStatus?: number | null
  NickNameTips?: string | null
  NickNameContent?: string | null
  AvatarAddressStatus?: number | null
  AvatarAddressTips?: string | null
  AvatarAddressContent?: string | null
}

export type UserCenterUserData = {
  userId?: string
  nick?: string
  gender?: number
  identity?: number
  userName?: string
  avatar?: string
  email?: string
  mobile?: string
  phone?: string
  mobileCode?: string
  areaCode?: string
  sex?: string | number
  realNameStatus?: string | number | boolean
  isRealName?: string | number | boolean
  mdp?: string
  aesp?: string
  mdp32?: string
  avatarFrame?: string
  isDefaultAvatar?: boolean
  isDefaultNick?: boolean
  type?: number
  ip?: string
  status?: number
  isCertified?: boolean
  realName?: string
  IDNumber?: string
  balance?: string | number | boolean
  spentAmount?: string | number | boolean
  vipExpiredAt?: string
  remainViews?: number
  isLifeVip?: boolean
  roleType?: number
  authStatus?: number
  isEmailConfirmed?: boolean
  isPhoneConfirmed?: boolean
  lastName?: string | number | boolean
  certificationType?: string | number | boolean
  areaFlag?: string
  shoppingAddressCount?: string | number | boolean
  traderFans?: string | number | boolean
  traderFansType?: number
  traderSubordinate?: string | number | boolean
  traderSubordinateType?: string | number | boolean
  inviteCode?: string | number | boolean
  ico?: string
  chineseshortnaame?: string
  englishshortname?: string
  traderphone?: string
  isRecentRegister?: boolean
  isShowMarketTool?: boolean
  fullName?: string
  userFirstName?: string
  salutation?: string
  identityName?: string
  wikinum?: string
  ishideworkexp?: boolean
  phonelocation?: string
  lock?: boolean
  LockType?: number
  countryCode?: string
  WikibitIntro?: string
  contactList?: string[]
  wikibitIsKol?: boolean
  ishavemajia?: boolean
  EnterpriseType?: string | number | boolean
  EnterpriseCode?: string
  isOpenWhatsApp?: boolean
  loginIdentityType?: number
  isFirstSelect?: boolean
  userStatus?: number
  isShowSwitch?: boolean
  enterpriseVIcon?: string
  enterpriseVIcon2?: string
  tagIcon?: string
  tagWords?: string
  tagBgColor?: string
  tagLableColor?: string
  tagLableBorder?: string
  staffTag?: string
  enterpriseName?: string
  businesscardCount?: number
  showNickName?: string
  showAvataraddress?: string
  level?: number
  nickNameColor?: string
  userToken?: string
  identityIcons?: string
  growthCenterUserStatus?: number
  darenIcon?: string
  vipExpiredTimestamp?: number
  official?: string
  officialColor?: string
  matemaskaddress?: string
  LoginToken?: string
  homeIsShowChooseIdentity?: boolean
  growIsShowChooseIdentity?: boolean
  identityIconNews?: string
}

export type UserRealName = {
  Text?: string
  Buttom?: string
  isAuth: boolean
}

export type UserCenterGetUserResponse = {
  code?: number
  data?: {
    usercenter?: {
      getuserv5?: {
        data: UserCenterUserData
      }
    }
  }
  message?: string
  succeed?: boolean
}

export const getUserInfo = (
  data: UserCenterGetUserParams,
  options: UserCenterGetUserOptions = {},
): Promise<UserCenterGetUserResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_GET_USER_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userId,
    },
  }

  return import.meta.server ? useServerFetch<UserCenterGetUserResponse>(requestConfig) : request(requestConfig)
}

export const getUserPhoneById = (
  data: UserCenterGetUserPhoneByIdParams,
): Promise<UserCenterGetUserPhoneByIdResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: api.homeClient,
    url: `${WIKIBITWEBV1}/invoke-v3/v3`,
    method: 'POST' as const,
    data,
    headers: {
      Routes: 'usercenter$getuserphonebyid',
    },
  }

  return import.meta.server ? useServerFetch<UserCenterGetUserPhoneByIdResponse>(requestConfig) : request(requestConfig)
}

export const uploaduseravatarv3 = (
  data: UserCenterUploadAvatarAuditParams,
  options: UserCenterUploadAvatarAuditOptions = {},
): Promise<UserCenterUploadAvatarAuditResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_UPLOAD_AVATAR_AUDIT_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userId,
    },
  }

  return import.meta.server
    ? useServerFetch<UserCenterUploadAvatarAuditResponse>(requestConfig)
    : request(requestConfig)
}

export const updateUserNick = (
  data: UserCenterUpdateNickParams,
  options: UserCenterUpdateNickOptions = {},
): Promise<UserCenterUpdateNickResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_UPDATE_NICK_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userId,
    },
  }

  return import.meta.server ? useServerFetch<UserCenterUpdateNickResponse>(requestConfig) : request(requestConfig)
}

export const USER_CENTER_UPDATE_GENDER_API_PATH = '/api/v4/bit/usercenter/updategender'

export type UserCenterUpdateGenderParams = {
  userId: string
  gender: number
}

export type UserCenterUpdateGenderOptions = {
  headerUserId?: string
}

export type UserCenterUpdateGenderResponse = Record<string, any> | null

export const updateUserGender = (
  data: UserCenterUpdateGenderParams,
  options: UserCenterUpdateGenderOptions = {},
): Promise<UserCenterUpdateGenderResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_UPDATE_GENDER_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userId,
      'Content-Type': 'application/json',
    },
  }

  return import.meta.server ? useServerFetch<UserCenterUpdateGenderResponse>(requestConfig) : request(requestConfig)
}

export const USER_CENTER_GET_USER_UPDATE_NICKNAME_OR_AVATAR_ADDRESS_API_PATH =
  '/api/v4/bit/usercenter/getuserupdatenicknameoravataraddress'

export type UserCenterGetUserUpdateNicknameOrAvatarAddressParams = {
  userid: string
}

export type UserCenterGetUserUpdateNicknameOrAvatarAddressOptions = {
  headerUserId?: string
}

export type UserCenterGetUserUpdateNicknameOrAvatarAddressResponse = Record<string, any> | null

export type UserUpdateNickData = {
  AvatarAddressContent?: string | null
  AvatarAddressStatus: number | null
  AvatarAddressTips?: string | null
  NickNameContent?: string | null
  NickNameStatus: number | null
  NickNameTips?: string | null
}

// 获取用户更新昵称或头像地址相关信息
export const getUserUpdateNicknameOrAvatarAddress = (
  data: UserCenterGetUserUpdateNicknameOrAvatarAddressParams,
  options: UserCenterGetUserUpdateNicknameOrAvatarAddressOptions = {},
): Promise<UserCenterGetUserUpdateNicknameOrAvatarAddressResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_GET_USER_UPDATE_NICKNAME_OR_AVATAR_ADDRESS_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userid,
      'Content-Type': 'application/json',
    },
  }

  return import.meta.server
    ? useServerFetch<UserCenterGetUserUpdateNicknameOrAvatarAddressResponse>(requestConfig)
    : request(requestConfig)
}

export const USER_CENTER_GET_USER_UPDATE_INFO_STATUS_API_PATH = '/api/v4/bit/usercenter/getuserupdateinfostatus'

export type UserCenterGetUserUpdateInfoStatusParams = {
  userid: string
}

export type UserCenterGetUserUpdateInfoStatusOptions = {
  headerUserId?: string
}

export type UserUpdateInfoStatus = {
  nicknameIsCanUpdate?: boolean
  avatarIsCanUpdate?: boolean
  Tips?: string // 15天内只能修改一次
}

export type UserCenterGetUserUpdateInfoStatusResponse = Record<string, any> | null

// 鑾峰彇鐢ㄦ埛澶村儚鍜屾橈拷鍙栨敼淇ョ姸鎬�
export const getUserUpdateInfoStatus = (
  data: UserCenterGetUserUpdateInfoStatusParams,
  options: UserCenterGetUserUpdateInfoStatusOptions = {},
): Promise<UserCenterGetUserUpdateInfoStatusResponse> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: USER_CENTER_GET_USER_UPDATE_INFO_STATUS_API_PATH,
    method: 'POST' as const,
    data,
    headers: {
      'X-User-Id': options.headerUserId || data.userid,
      'Content-Type': 'application/json',
    },
  }

  return import.meta.server
    ? useServerFetch<UserCenterGetUserUpdateInfoStatusResponse>(requestConfig)
    : request(requestConfig)
}
